import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAllDetails } from "../../service/ApiService";
import { GET_DETAIL_SUMMARY_TAXPAYER, GET_FORM_PAYMENT_DETAIL } from "../../config/ApiConstant";
import { nameTemplate } from "../../appconfig/TemplateFieldSetting";

const PaymentSuccess = () => {
  const [isVisible, setIsVisible] = useState(false);

  // loading
  const [pageLoading, setPageLoading] = useState<boolean>(false);

  //   payment Data
  const [paymentData, setPaymentData] = useState<any>({});

  // balance amount array of obj
  const [balanceAmountArray, setBalanceAmountArray] = useState<any>([]);

  //   form id from param
  const { taxformId } = useParams();
  const id = taxformId ? atob(taxformId) : null;

  useEffect(() => {
    // Trigger animations on mount
    setIsVisible(true);
    getTaxPayerSummary();
  }, []);

  const getTaxPayerSummary = async () => {
    try {
      setPageLoading(true);
      const response = await getAllDetails(`${GET_DETAIL_SUMMARY_TAXPAYER}/${id}`);

      if (response) {
        setPaymentData(response);
        setBalanceAmountArray(response?.payment_data);
        setPageLoading(false);
      }
    } catch (error) {
      setPageLoading(false);
    }
  };

  // display balance amount
  const balanceAmount =
    balanceAmountArray.length > 0 && (balanceAmountArray[0].amount !== undefined || balanceAmountArray[0].amount !== null)
      ? `$${balanceAmountArray[0].amount}`
      : "-";

  return (
    <>
      <div className="payment-success-container">
        <div className={`success-card ${isVisible ? "visible" : ""}`}>
          {/* Success Message */}
          <div className="message-section flex flex-column align-items-center justify-content-center">
            <div className="success-icon ">
              <svg viewBox="0 0 100 100" className="checkmark ">
                <circle className="checkmark-circle" cx="50" cy="50" r="45" />
                <path className="checkmark-check" d="M25,50 L40,65 L75,30" />
              </svg>
            </div>
            <h1 className="success-title flex align-items-center justify-content-center gap-2">
              <span>{/* <i className="pi pi-check-circle flex align-item-center" style={{ fontSize: "2.8rem", color: "#22c55e" }}></i> */}</span>
              Payment Successful!
            </h1>
          </div>

          {/* Transaction Details */}
          <div className="transaction-summary">
            <div className="amount-display mt-0">
              <span className="currency-symbol"></span>
              <span className="amount-value">{balanceAmount}</span>
            </div>
          </div>

          {/* Payment Details */}
          <div className="details-section">
            <h2 className="section-title">Payment Details</h2>

            <div className="detail-grid">
              <div className="detail-item">
                <div className="detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <div className="detail-content">
                  <span className="detail-label">Name</span>
                  <span className="detail-value"> {nameTemplate(paymentData)}</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </div>
                <div className="detail-content">
                  <span className="detail-label">Email</span>
                  <span className="detail-value">{paymentData?.email}</span>
                </div>
              </div>

              <div className="detail-item">
                <div className="detail-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div className="detail-content">
                  <span className="detail-label">Phone</span>
                  <span className="detail-value">{paymentData?.phone}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
